import { createAsyncThunk } from '@reduxjs/toolkit';
import { URLS } from 'constants/api.constants';
import { axiosInstance } from 'utils/axios';

export const getProfileDetails = createAsyncThunk(
  'auth/getProfile',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.AUTH.GET_PROFILE);
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const profileUpdate = createAsyncThunk(
  'auth/profile-update',
  async (params, thunkAPI) => {
    try {
      console.log(params);
      const formData = new FormData();
      if (typeof params.firstName === 'string')
        formData.append('first_name', params.firstName);
      if (typeof params.lastName === 'string')
        formData.append('last_name', params.lastName);
      if (typeof params.bio === 'string') formData.append('bio', params.bio);
      if (typeof params.country === 'string')
        formData.append('country', params.country);
      if (params.profileImage && params.profileImage instanceof File) {
        formData.append('file', params.profileImage);
      }
      if (typeof params.is_empty_subscription === 'boolean') {
        formData.append('is_empty_subscription', params.is_empty_subscription);
      }

      console.log("🚀 ~ params.emailSubs:", params.emailSubs)
      if (params.emailSubs) {
        if (params.emailSubs.length > 0) {
          params.emailSubs.forEach((id, index) => {
            formData.append(`email_subscription[${index}]`, id);
          });
        } else {
          formData.append('email_subscription', ['']);
        }
      }
      const response = await axiosInstance.post(URLS.AUTH.PROFILE, formData);
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const toggleAccountActivation = createAsyncThunk(
  'auth/toggle-account-activation',
  async (params, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(URLS.AUTH.STATUS, params);
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const deleteAccount = createAsyncThunk(
  'auth/delete-account',
  async (params, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(URLS.AUTH.DELETE_USER, params);
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const getEmailTopics = createAsyncThunk(
  'auth/get-email-topics',
  async (_, thunkAPI) => {
    try {
      const response = await axiosInstance.get(URLS.EMAIL.GET_TOPICS);
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const changeUserPassword = createAsyncThunk(
  'auth/change-user-password',
  async (params, thunkAPI) => {
    try {
      const response = await axiosInstance.post(
        URLS.AUTH.CHANGE_PASSWORD,
        params
      );
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);

export const updateUserStatus = createAsyncThunk(
  'auth/deactivate-account',
  async (params, thunkAPI) => {
    try {
      const response = await axiosInstance.patch(
        URLS.AUTH.UPDATE_STATUS,
        params
      );
      if (response.data?.success) return response.data;
      else thunkAPI.rejectWithValue(response.data?.message);
    } catch (error) {
      return thunkAPI.rejectWithValue(error?.message);
    }
  }
);
